import React from 'react';

type dateHeadingProps = {
   date: Date;
}

const months = [
   'January',
   'February',
   'March',
   'April',
   'May',
   'June',
   'July',
   'August',
   'September',
   'October',
   'November',
   'December'
];

const days = [
   "Sunday",
   "Monday",
   "Tuesday",
   "Wednesday",
   "Thursday",
   "Friday",
   "Saturday",
   "Sunday"
];

const getOrdinalNum = (n: number): string => {
   let selector;

   if (n <= 0) {
      selector = 4;
   } else if ((n > 3 && n < 21) || n % 10 > 3) {
      selector = 0;
   } else {
      selector = n % 10;
   }

   return n + ['th', 'st', 'nd', 'rd', ''][selector];
};

const DateHeading: React.FC<dateHeadingProps> = ({ date }) => (
   <h1 className="p-1 lg:p-4 pb-1 text-xl lg:text-4xl text-gray-100 underline">
      {
         //Saturday 20th February 2021
         days[date.getUTCDay()] + " " +
         getOrdinalNum(date.getUTCDate()) + " " +
         months[date.getUTCMonth()] + " " +
         date.getUTCFullYear()
      }
   </h1>
)

export default DateHeading;